import { render, staticRenderFns } from "./costsDatabase.vue?vue&type=template&id=391f3cb9&"
import script from "./costsDatabase.vue?vue&type=script&lang=js&"
export * from "./costsDatabase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports